import { Vue } from 'vue-property-decorator'
import { IAskActivity } from '@/interfaces/workflow'
import { User } from '@/interfaces/IUser'
import { IGuardianGroup } from '@/interfaces/Guardian'
import { IProposta } from '@/interfaces'
import { CaptureEvent, Events } from '@/services/AmplitudeService'
import { FornecedorHelper } from '@/utils/FornecedorHelper'

export interface IActivity {
	input: IAskActivity
	object: IProposta
	isLoading: boolean
	setLoading(state: boolean): void
	isWaiting: boolean
	isAnswered: boolean
	allowedGroups: Array<IGuardianGroup> | null
	proposal: IProposta
	captureEvent(action: string): void
}

export class Activity extends Vue implements IActivity {
	allowedGroups: IGuardianGroup[] | null = null
	get isWaiting() {
		return this.input?.status == 'WAITING'
	}

	get isAnswered() {
		return this.input?.status == 'ANSWERED'
	}

	get currentUser() {
		const { state } = this.$store
		return state.user as User.IUser
	}

	get proposal() {
		return this.$props.object as IProposta
	}

	input!: IAskActivity
	object!: IProposta

	isLoading: boolean = false
	setLoading(state: boolean): void {
		this.isLoading = state
	}

	get isUserAllowed() {
		if (this.input.metadata.rules?.length > 0) {
			const isUserRuleExists = this.input.metadata.rules.find((rule) => this.currentUser.rules.includes(rule))
			return isUserRuleExists != undefined
		}

		if (this.input.metadata.rules?.length == 0 || !this.input.metadata.rules) return true

		return false
	}

	captureEvent(action: string) {
		const { state } = this.$store

		try {
			CaptureEvent(Events.WorkflowActivityAnswered, {
				bank: FornecedorHelper.getNome(this.proposal?.idFornecEmissao),
				question: this.input.metadata.question,
				action: action,
				answer: action,
				user: state.user?.id
			})
		} catch (e) {
			console.error('Error to sent event to Amplitude')
			console.error(e)
		}
	}
}
